



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import OnFleetService from '../services/OnFleetService';
import moment from 'moment';
import firebase from 'firebase/app';
import 'firebase/database';
import Constants from '../config/constants';

@Component
export default class ManualExport extends Vue {
    private name: string = '';
    private phone: string = '';
    private address: string = '';
    private apartment: string = '';
    private notes: string = '';
    private quantity: number = 0;
    private menuAfterTime = false;
    private timeAfter: any = Constants.startOfOfficeDeliveryTime;
    private menuBeforeTime = false;
    private timeBefore: any = Constants.endOfOfficeDeliveryTime;
    private menu = false;
    private deliveryDate = moment().toISOString();

    @Prop()
    private item: any;

    @Prop()
    private user: any;

    @Watch('item')
    private async onItemChange(value: any, oldValue: any) {
        this.name = value.name;
        this.phone = value.phone;
        this.address = value.address;
        this.apartment = value.unit || '';
        this.quantity = value.quantity;
        this.notes = value.instructions;
    }

    private async createTask() {
        const db = firebase.database();
        const userRef = db.ref(`orders/${this.yearWeek}/${this.item.uid}/logistics/${this.day}/status`);
        let timeBefore = this.item.location === 'home' ? Constants.endOfHomeDeliveryTime : Constants.endOfOfficeDeliveryTime;
        let timeAfter = this.item.location === 'home' ? Constants.startOfHomeDeliveryTime : Constants.startOfOfficeDeliveryTime;
        if (this.user.schedule && this.user.schedule[this.day]) {
            timeBefore = this.user.schedule[this.day].time_before || Constants.endOfOfficeDeliveryTime;
            timeAfter = this.user.schedule[this.day].time_after || Constants.startOfOfficeDeliveryTime;
        }
        try {
            const recipient: any = {
                name: this.name
            };
            if (this.phone) {
                recipient.phone = this.phone;
            }

            const response = await OnFleetService.createTask({
                destination: {
                    address: {
                        unparsed: this.address,
                        apartment: this.apartment
                    }
                },
                recipients: [recipient],
                recipientName: recipient.name,
                recipientNotes: recipient.notes,
                quantity: this.quantity,
                notes: this.notes,
                completeBefore: moment(`${this.parseDate()} ${timeBefore}`).valueOf(),
                completeAfter: moment(`${this.parseDate()} ${timeAfter}`).valueOf()
            });
            await userRef.set('exported');
            this.item.status = 'exported';
            this.$emit('update:item', this.item);
        } catch (e) {
            await userRef.set('error');
            this.item.status = 'error';
            this.$emit('update:item', this.item);
        } finally {
            this.$emit('update:dialog', false);
        }
    }

    private parseDate() {
        return moment(this.deliveryDate).format('YYYY-MM-DD');
    }

    get day() {
        return moment(this.deliveryDate).format('ddd').toLowerCase();
    }

    get yearWeek() {
        return moment(this.deliveryDate).format('gggg_w');
        //const year = moment(this.deliveryDate).year();
        //const week = moment(this.deliveryDate).week();
        //return `${year}_${week}`;
    }
}
